import React from 'react';

const Projects = () => {
  console.log("Projects component rendering");
  
  return (
    <section id="projects" className="section projects">
      <h1 className="title">Projects</h1>
      <div className="list">
        <div className="card item">
          <div className="name">Lua Development Communities</div>
          <p className="project-description">Leading various development communities focused on Lua scripting for gaming platforms.</p>
          <div className="project-links">
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> Thedocscripts</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> ALD Scripting</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
          </div>
        </div>
        
        <div className="card item">
          <div className="name">Fivem Server Communities</div>
          <p className="project-description">Leading various Fivem servers.</p>
          <div className="project-links">
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> Macabros RP</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> DesperadosRP</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> Non Stop</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
            <a className="button" href="" target="_blank" rel="noopener noreferrer">
              <span className="border"></span>
              <span className="label"><i className="fa-brands fa-discord"></i> UrbanRoleplay</span>
              <span className="label-hover">
                <span className="inner"><i className="fa-brands fa-discord"></i> Join Community</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects; 